import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function Notebook() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section id="cuaderno" ref={ref} className="relative py-32 px-6 bg-dark-800">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative w-full h-[600px] rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/55de03a58447b22c9804f3000d5f2dfc/07f42e5ae2f1b1f8177297490b22d088.png"
                alt="Cuaderno de La Magdalena"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
            
            {/* Decorative frame */}
            <div className="absolute -top-6 -left-6 w-full h-full border-2 border-gold-500/30 rounded-lg -z-10"></div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <i className="ri-book-open-line text-5xl text-gold-400"></i>
              <h2 className="font-serif text-5xl md:text-6xl text-gold-400">
                El Cuaderno
              </h2>
            </div>

            <h3 className="font-serif text-3xl text-warm-100 mb-8">
              Cuaderno de La Magdalena
            </h3>

            <div className="space-y-6 mb-10">
              <p className="font-sans text-lg text-warm-200 leading-relaxed">
                Tu compañero personal en esta peregrinación de 40 días. Un espacio sagrado para escribir, reflexionar y encontrarte con Dios a través de la experiencia de María Magdalena. Puedes recibir el cuaderno en versión digital, pagando directamente aquí en la siguiente pantalla en el enlace de El Curso, y se te estará enviando directamente a tu email. Pero si lo prefieres impreso, usa el enlace a continuación.
              </p>

              <div className="flex items-baseline gap-4">
                <span className="font-serif text-5xl text-gold-400">$15</span>
                <span className="font-sans text-warm-200">USD</span>
              </div>

              <div className="bg-gold-500/10 border border-gold-500/30 rounded-lg p-6">
                <p className="font-sans text-warm-100 flex items-start gap-3">
                  <i className="ri-information-line text-2xl text-gold-400 flex-shrink-0"></i>
                  <span>
                    <strong className="text-gold-400">Importante:</strong> El cuaderno se utiliza diariamente y es la base del camino, es requerido en formato físico o digital. El costo en Amazon no es parte del curso.
                  </span>
                </p>
              </div>
            </div>

            <div className="space-y-4">
              <a
                href="https://a.co/d/4CEwbsa"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-3 px-10 py-5 bg-gold-500 text-dark-900 font-sans font-semibold text-lg rounded-lg hover:bg-gold-400 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
              >
                <i className="ri-amazon-line text-2xl"></i>
                Comprar en Amazon
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
